import * as React from 'react';
import MuiTooltip, { TooltipProps as MuiTooltipProps } from '@mui/material/Tooltip';

/**
 * Plooto Tooltip.
 *
 * Identical to MUI v4's [Tooltip component](https://v4.mui.com/components/tooltips/), except we display a tooltip arrow by default.
 *
 * See the MUI component and the [Tooltip API](https://v4.mui.com/components/tooltips/) for additional usage details.
 *
 * @param props MUI Tooltip props
 * @returns Function component
 */
const Tooltip: React.FC<MuiTooltipProps> = (props: MuiTooltipProps) => (
  <MuiTooltip arrow {...props} />
);

export type { MuiTooltipProps as TooltipProps };
export default Tooltip;
